<h2>Password Reset Email Sent</h2>
<p>An email has been sent to <strong>{{email}}</strong> with instructions on how to reset your password.</p>
<p>If you didn't receive the email, please check your spam folder.</p>

<div class="error-message" role="alert" *ngIf="errorMessage">
    <div class="d-flex flex-nowrap">
        <span class="fa fa-exclamation-triangle align-self-center mx-2"></span>
        <span class="mx-1">{{errorMessage}}</span>
        <span class="fa fa-exclamation-triangle align-self-center mx-2"></span>
    </div>
</div>

<div class="d-flex justify-content-between mt-6 mb-4">
    <div
        class="text-button"
        [class.is-loading]="isSending || !isResendEnabled"
        (click)="resend()"
        data-testid="reset-email-sent-resend-password-reset-email">
        <span *ngIf="!isSending && isResendEnabled">Resend Password Reset Email</span>
        <span *ngIf="!isSending && !isResendEnabled">Please check your email...</span>
        <span *ngIf="isSending">Resending email...</span>
    </div>

    <a routerLink="/auth/login" data-testid="reset-email-sent-return-to-login">
        Return to Login
    </a>
</div>


// WEBPACK FOOTER //
// ./src/app/auth/forgot-password/reset-email-sent/reset-email-sent.component.html